import { computed } from 'vue'
import {
  FileExtraProp,
  FileStatus,
  UploadStatus,
} from '@pt/store/assets/uploader.type'
import store from '@pt/store'

export default () => {
  const isUploadWaitingStatus = computed(() => {
    return store.state.assets.uploader.uploadStatus === UploadStatus.waiting
  })

  const isUploadingStatus = computed(() => {
    return store.state.assets.uploader.uploadStatus === UploadStatus.uploading
  })

  const isUploadEndStatus = computed(() => {
    return store.state.assets.uploader.uploadStatus === UploadStatus.uploadEnd
  })

  const fileList = computed(() => {
    return store.state.assets.uploader.fileList
  })

  const fileExtraList = computed(() => {
    return store.state.assets.uploader.fileExtraList
  })

  const selectedFileList = computed(() => {
    return store.state.assets.uploader.fileExtraList.filter(
      (file: FileExtraProp) => file.selected,
    )
  })

  const uploaderSuccessFileList = computed(() => {
    return store.state.assets.uploader.fileExtraList.filter(
      (file: FileExtraProp) => file.status === FileStatus.uploadSuccess,
    )
  })

  const selectedFileSize = computed(() => {
    const size = selectedFileList.value.reduce(
      (sum: number, file: FileExtraProp) => {
        return sum + file.size
      },
      0,
    )
    return size
  })

  const totalSize = computed(() => {
    return store.state.assets.uploader.totalSize
  })

  const usedSize = computed(() => {
    return store.state.assets.uploader.usedSize + selectedFileSize.value
  })
  return {
    isUploadWaitingStatus,
    isUploadingStatus,
    isUploadEndStatus,
    fileList,
    fileExtraList,
    selectedFileList,
    uploaderSuccessFileList,
    selectedFileSize,
    totalSize,
    usedSize,
  }
}
